/** i18next: switching language updates every text without reloading the page (P0-03). */

import {
  LANGUAGE_STORAGE_KEY,
  REFERENCE_LANGUAGE,
  isRtl,
  isSupported,
  resources,
} from "@agencyos/i18n";
import i18next from "i18next";
import { initReactI18next } from "react-i18next";

import { readStorage, writeStorage } from "./storage";

function initialLanguage(): string {
  const saved = readStorage(LANGUAGE_STORAGE_KEY);
  if (saved && isSupported(saved)) return saved;
  const browser = navigator.language.split("-")[0] ?? REFERENCE_LANGUAGE;
  return isSupported(browser) ? browser : REFERENCE_LANGUAGE;
}

export function applyDocumentLanguage(language: string): void {
  document.documentElement.lang = language;
  document.documentElement.dir = isRtl(language) ? "rtl" : "ltr";
}

void i18next.use(initReactI18next).init({
  resources,
  lng: initialLanguage(),
  fallbackLng: REFERENCE_LANGUAGE,
  interpolation: { escapeValue: false }, // React already escapes
  returnNull: false,
});

applyDocumentLanguage(i18next.language);
i18next.on("languageChanged", (language) => {
  writeStorage(LANGUAGE_STORAGE_KEY, language);
  applyDocumentLanguage(language);
});

export default i18next;
